import {useCallback, useRef, useState} from 'react'
import {NodeOneDispatch} from '../../graphql/types/despachoTypes'
import {COLOR_PRIMARY} from '../../helpers/consts'
import {parseId} from '../../helpers'
import {Button} from 'react-bootstrap'
import html2pdf from 'html2pdf.js'
import {Spinner} from '../Spinner'
import moment from 'moment'
import {useReactToPrint} from 'react-to-print'

const BG_PRIMARY = '#ff8d00'
const RADIUS = '6px'

const PRODUCTS_VIEW = [
  {
    key: 'info1',
    product_1: {
      name: 'BASE GRANULAR',
    },
    product_2: {
      name: 'SUBBASE GRANULAR',
    },
  },
  {
    key: 'info2',
    product_1: {
      name: 'ARENA',
    },
    product_2: {
      name: 'GRAVA 3/4',
    },
  },
  {
    key: 'info3',
    product_1: {
      name: 'PIEDRA',
    },
    product_2: {
      name: 'GRAVA 1/2',
    },
  },
  {
    key: 'info4',
    product_1: {
      name: 'RECEBO',
    },
    product_2: {
      name: "GRAVA 1'",
    },
  },
  {
    key: 'info5',
    product_1: {
      name: 'MEJORAMIENTO',
    },
    product_2: {
      name: 'OTRO',
    },
  },
]

export const ViewDispatchBill = ({
  dispatch,
  idFact,
}: {
  dispatch: NodeOneDispatch
  idFact: string
}) => {
  const divRef = useRef<HTMLDivElement>(null)
  const [loadingDown, setLoadingDown] = useState(false)

  /* const handleAfterPrint = useCallback(() => {
    console.log('`onAfterPrint` called')
  }, []) */

  const handleBeforePrint = useCallback(() => {
    return Promise.resolve()
  }, [])

  const printFn = useReactToPrint({
    contentRef: divRef,
    documentTitle: `Despacho-${parseId(dispatch.id)}`,
    // onAfterPrint: handleAfterPrint,
    onBeforePrint: handleBeforePrint,
  })

  const handleDownload = () => {
    if (!divRef.current) return
    setLoadingDown(true)
    html2pdf()
      .set({
        margin: 2,
        image: {type: 'jpeg'},
        html2canvas: {
          scale: 2,
          letterRendering: true,
          useCORS: true,
        },
        filename: `Despacho-${parseId(dispatch.id)}.pdf`,
      })
      .from(divRef.current)
      .save()
      .then(() => {
        setLoadingDown(false)
      })
  }

  /* const print = () => {
    const content = divRef.current?.parentElement?.innerHTML

    if (!content) return

    const printWindow = window.open('', '', 'height=600,width=800')

    if (!printWindow) return

    console.log('content', content)

    printWindow.document.write('<html><head><title>Imprimir</title>')
    printWindow.document.write('</head><body>')
    printWindow.document.write(content)
    printWindow.document.write('</body></html>')

    printWindow.document.close()
    printWindow.focus()

    printWindow.print()

    printWindow.close()
  } */

  const products = dispatch.dispatchproductthroughSet.edges
  return (
    <>
      <div className='p-4' style={{overflowX: 'auto'}}>
        <div
          ref={divRef}
          style={{
            minWidth: '700px',
            padding: '20px',
          }}
        >
          <header
            style={{
              display: 'flex',
              justifyContent: 'space-around',
              alignItems: 'center',
            }}
          >
            <div>
              <div style={{position: 'relative'}}>
                <img
                  src='/media/jeisat/logo.png'
                  alt='Logo jeisat'
                  style={{
                    width: '100%',
                    height: 'auto',
                    maxWidth: '290px',
                  }}
                />
                <span
                  style={{
                    position: 'absolute',
                    fontSize: '8px',
                    bottom: '-6px',
                    right: '0%',
                    left: '108px',
                  }}
                >
                  NIT. 900.947.196 - 4 REGIMEN COMUN
                </span>
              </div>
            </div>

            <div style={{textAlign: 'center', fontSize: '11px'}}>
              <p style={{margin: 0, padding: 0}}>Transversal 1E # 11 - 13 Moscopan</p>
              <p style={{margin: 0, padding: 0}}>Popayán - Cauca</p>
              <p style={{margin: 0, padding: 0}}>Cel: 312 746 1833 Tel: 833 6804</p>
              <p style={{margin: 0, padding: 0}}>
                CANTERA: 313 610 3014{' '}
                <i className='bi bi-whatsapp' style={{color: COLOR_PRIMARY}} />
              </p>
              <p style={{margin: 0, padding: 0, marginTop: '-4px'}}>
                E-mail: ingenieriajeisat@gmail.com
              </p>
            </div>

            <div>
              <div
                style={{
                  border: `1px solid ${COLOR_PRIMARY}`,
                  borderRadius: '8px',
                  overflow: 'hidden',
                }}
              >
                <h3
                  style={{
                    flex: 0,
                    flexBasis: '200px',
                    fontSize: '1.1em',
                    textAlign: 'center',
                    backgroundColor: BG_PRIMARY,
                    padding: '1em',
                    color: 'white',
                    fontWeight: '900',
                  }}
                >
                  ORDEN DE PEDIDO
                </h3>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    padding: '1em',
                  }}
                >
                  <span style={{color: '#FF0000', fontSize: '18px', fontWeight: 'bold'}}>
                    {dispatch.invoiceId}
                  </span>
                </div>
              </div>
            </div>
          </header>

          <main style={{marginTop: '5px', display: 'flex', gap: '4px', minHeight: '385px'}}>
            <div
              style={{
                flex: 1,
                borderRadius: RADIUS,
                overflow: 'hidden',
                border: `2px solid ${COLOR_PRIMARY}`,
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: 'column',
              }}
            >
              <div
                style={{backgroundColor: BG_PRIMARY, display: 'flex', borderBottom: '2px solid'}}
              >
                <div style={{color: 'white', flex: 1, padding: '2px 8px', fontSize: '20px'}}>
                  FECHA
                </div>
                <div
                  style={{
                    backgroundColor: 'white',
                    color: `${BG_PRIMARY}55`,
                    borderLeft: `1px solid ${COLOR_PRIMARY}`,
                    padding: '2px 8px',
                    fontSize: '18px',
                    position: 'relative',
                  }}
                >
                  <span
                    style={{
                      position: 'absolute',
                      top: '2px',
                      left: '2px',
                      fontSize: '20px',
                      color: '#524949',
                      fontWeight: '600',
                    }}
                  >
                    {moment(dispatch.departureDatetime).format('DD')}
                  </span>
                  DD
                </div>
                <div
                  style={{
                    backgroundColor: 'white',
                    color: `${BG_PRIMARY}55`,
                    borderLeft: `1px solid ${COLOR_PRIMARY}`,
                    padding: '2px 8px',
                    fontSize: '18px',
                    position: 'relative',
                  }}
                >
                  MM
                  <span
                    style={{
                      position: 'absolute',
                      top: '2px',
                      left: '2px',
                      fontSize: '20px',
                      color: '#524949',
                      fontWeight: '600',
                    }}
                  >
                    {moment(dispatch.departureDatetime).format('MM')}
                  </span>
                </div>
                <div
                  style={{
                    backgroundColor: 'white',
                    color: `${BG_PRIMARY}55`,
                    borderLeft: `1px solid ${COLOR_PRIMARY}`,
                    padding: '2px 8px',
                    fontSize: '18px',
                    position: 'relative',
                  }}
                >
                  AA
                  <span
                    style={{
                      position: 'absolute',
                      top: '2px',
                      left: '2px',
                      fontSize: '20px',
                      color: '#524949',
                      fontWeight: '600',
                    }}
                  >
                    {moment(dispatch.departureDatetime).format('YY')}
                  </span>
                </div>
              </div>

              <div
                style={{
                  padding: '20px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  flex: 0,
                }}
              >
                <span>SEÑOR (ES):</span>
                {/* <span style={{display: 'block', borderBottom: '1px solid', marginTop: '24px'}} /> */}
                <span
                  style={{
                    display: 'block',
                    marginTop: '6px',
                    fontSize: '20px',
                    fontWeight: 'bolder',
                    textTransform: 'uppercase',
                    fontStyle: 'italic',
                    textDecoration: 'underline',
                  }}
                >
                  {dispatch.sale.client.name}
                </span>
                {/* <span
                  style={{
                    display: 'block',
                    borderBottom: '1px solid',
                    marginTop: '24px',
                    marginBottom: '24px',
                  }}
                /> */}
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  flex: 1,
                  borderTop: '1px solid',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    borderBottom: '1px solid',
                  }}
                >
                  <div style={{flex: 1, padding: '12px 6px', fontWeight: 'bold'}}>
                    ORDEN DE DESPACHO No.
                  </div>
                  <div style={{flex: 1, padding: '12px 6px', borderLeft: '1px solid'}}>
                    <span style={{textTransform: 'uppercase', fontSize: '20px'}}>{idFact}</span>
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    borderBottom: '1px solid',
                    flex: 1,
                  }}
                >
                  <div style={{flex: 1, padding: '12px 6px', fontWeight: 'bold'}}>PLACA</div>
                  <div style={{flex: 1, padding: '12px 6px', borderLeft: '1px solid'}}>
                    <span style={{textTransform: 'uppercase', fontSize: '20px'}}>
                      {dispatch.plate}
                    </span>
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    borderBottom: '1px solid',
                    flex: 1,
                  }}
                >
                  <div style={{flex: 1, padding: '10px 6px', fontWeight: 'bold'}}>
                    HORA DE SALIDA
                  </div>
                  <div style={{flex: 1, padding: '10px 6px', borderLeft: '1px solid'}}>
                    <span style={{textTransform: 'uppercase', fontSize: '20px'}}>
                      {moment(dispatch.departureDatetime).format('hh:mm A')}
                    </span>
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flex: 1,
                  }}
                >
                  <div style={{flex: 1, padding: '10px 6px', fontWeight: 'bold'}}>
                    HORA DE LLEGADA
                  </div>
                  <div style={{flex: 1, padding: '10px 6px', borderLeft: '1px solid'}}></div>
                </div>
              </div>
            </div>
            <div
              style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <div
                style={{
                  borderRadius: RADIUS,
                  overflow: 'hidden',
                  border: `2px solid ${COLOR_PRIMARY}`,
                }}
              >
                {PRODUCTS_VIEW.map(({key, product_1, product_2}) => (
                  <div
                    key={key}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      padding: '5px',
                      fontSize: '12px',
                    }}
                  >
                    <div style={{flex: 1, display: 'flex', gap: '5px', alignItems: 'center'}}>
                      <span
                        style={{
                          display: 'inline-block',
                          width: '35px',
                          minWidth: '35px',
                          height: '35px',
                          border: '1px solid',
                          borderRadius: '4px',
                          position: 'relative',
                        }}
                      >
                        {products.some(
                          (pro) =>
                            pro.node.product.name.toLowerCase() === product_1.name.toLowerCase()
                        ) && (
                          <span
                            style={{
                              position: 'absolute',
                              fontSize: '38px',
                              fontWeight: 'bold',
                              top: 0,
                              left: 0,
                              textAlign: 'center',
                              width: '100%',
                              height: '100%',
                              lineHeight: '26px',
                            }}
                          >
                            {
                              products.find(
                                (pro) =>
                                  pro.node.product.name.toLowerCase() ===
                                  product_1.name.toLowerCase()
                              )?.node.quantityDispatch
                            }
                          </span>
                        )}
                      </span>
                      <span style={{wordBreak: 'break-word'}}>{product_1.name}</span>
                    </div>
                    <div style={{flex: 1, display: 'flex', gap: '5px', alignItems: 'center'}}>
                      <span
                        style={{
                          display: 'inline-block',
                          width: '35px',
                          minWidth: '35px',
                          height: '35px',
                          border: '1px solid',
                          borderRadius: '4px',
                          position: 'relative',
                        }}
                      >
                        {product_2.name.toLowerCase() ===
                          dispatch.dispatchproductthroughSet.edges[0].node.product.name.toLowerCase() && (
                          <span
                            style={{
                              position: 'absolute',
                              fontSize: '38px',
                              fontWeight: 'bold',
                              top: 4,
                              left: 0,
                              textAlign: 'center',
                              width: '100%',
                              height: '100%',
                              lineHeight: '26px',
                            }}
                          >
                            {dispatch.dispatchproductthroughSet.edges[0].node.quantityDispatch}
                          </span>
                        )}
                      </span>
                      <span style={{wordBreak: 'break-word'}}>{product_2.name}</span>
                    </div>
                  </div>
                ))}
              </div>

              <div
                style={{
                  marginTop: '4px',
                  borderRadius: RADIUS,
                  overflow: 'hidden',
                  border: `2px solid ${COLOR_PRIMARY}`,
                  padding: '10px',
                }}
              >
                <span style={{display: 'block', margin: '10px 5px', borderBottom: '1px solid'}}>
                  <span
                    style={{
                      borderBottom: '1px solid white',
                      paddingBottom: '2px',
                    }}
                  >
                    OBSERVACIONES:
                  </span>
                  <span
                    style={{
                      textTransform: 'capitalize',
                      margin: '15px 5px',
                      fontSize: '12px',
                      color: '#4c4848',
                      fontStyle: 'italic',
                    }}
                  >
                    {products.length} productos
                  </span>
                </span>
                {dispatch.observations ? (
                  <>
                    <span
                      style={{
                        display: 'block',
                        margin: '15px 5px',
                        textDecoration: 'underline',
                        color: '#4c4848',
                        fontStyle: 'italic',
                      }}
                    >
                      {dispatch.observations}
                    </span>
                  </>
                ) : (
                  <>
                    <span
                      style={{display: 'block', margin: '15px 5px' /* borderBottom: '1px solid' */}}
                    >
                      <span
                        style={{
                          textTransform: 'capitalize',
                          margin: '15px 5px',
                          fontSize: '12px',
                          color: '#4c4848',
                          fontStyle: 'italic',
                          textDecoration: 'underline',
                        }}
                      >
                        {products
                          .map(
                            (pro) =>
                              `${pro.node.quantityDispatch} de ${pro.node.product.unitType} ${pro.node.product.name}`
                          )
                          .join(', ')}
                      </span>
                    </span>
                    <span
                      style={{display: 'block', margin: '15px 5px', borderBottom: '1px solid'}}
                    />
                    <span
                      style={{display: 'block', margin: '15px 5px', borderBottom: '1px solid'}}
                    />
                  </>
                )}
              </div>
            </div>
            <div style={{flex: 0, flexBasis: '160px'}}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  border: '2px solid',
                  borderRadius: RADIUS,
                  height: '100%',
                }}
              >
                <div
                  style={{
                    flex: 1,
                    textAlign: 'center',
                    padding: '5px',
                    borderBottom: '2px solid',
                    width: '100%',
                  }}
                >
                  DESPACHADO POR
                  <p
                    style={{
                      textTransform: 'capitalize',
                      fontStyle: 'italic',
                      fontSize: '20px',
                      wordBreak: 'break-word',
                    }}
                  >
                    {dispatch.dispatchedBy}
                  </p>
                </div>
                <div
                  style={{
                    flex: 1,
                    textAlign: 'center',
                    padding: '5px',
                    borderBottom: '2px solid',
                    width: '100%',
                  }}
                >
                  TRANSPORTADO POR
                </div>
                <div
                  style={{
                    flex: 1,
                    textAlign: 'center',
                    padding: '5px',
                    width: '100%',
                  }}
                >
                  RECIBIDO POR
                </div>
              </div>
            </div>
          </main>
          <footer style={{color: COLOR_PRIMARY, fontWeight: 'bold', textAlign: 'center'}}>
            PASADO 30 DÍAS NO SE REALIZARÁ LA DEVOLUCIÓN DEL MATERIAL NI DEL DINERO
          </footer>
        </div>
      </div>
      <div className='mt-4 w-100 d-flex align-items-center justify-content-end'>
        <Button
          variant='info'
          className='d-flex align-items-center gap-2 me-2'
          onClick={() => printFn()}
        >
          <i className='bi bi-printer-fill text-light' />
          Imprimir
        </Button>
        <Button
          variant='dark'
          className='d-flex align-items-center gap-2'
          onClick={handleDownload}
          disabled={loadingDown}
        >
          {loadingDown ? (
            <Spinner size='12px' color='light' />
          ) : (
            <i className='bi bi-download text-light' />
          )}
          Descargar
        </Button>
      </div>
    </>
  )
}
